import { useMemo } from 'react';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { useJsmRepackagingAnnouncementResource } from '@atlassian/jira-router-resources-jsm-repackaging-announcement/src/services/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { isInJsmGlobalSettingsBoundary } from './utils.tsx';

export const useBannerJsmPackagingUpdates = () => {
	const currentRoute = useCurrentRoute();
	const { data: project } = useProjectContext();
	const accountId = useAccountId();

	const isServiceProject = project?.projectType === SERVICE_DESK_PROJECT;
	const isInJsmBoundary = useMemo(
		() => isInJsmGlobalSettingsBoundary(currentRoute.path) || isServiceProject,
		[isServiceProject, currentRoute.path],
	);
	const { shouldShow, dismissAnnouncement } = useJsmRepackagingAnnouncementResource(accountId);

	return useMemo(
		() => ({
			isEnabled: isInJsmBoundary && shouldShow && fg('jsm-packaging-pricing-changes-announcement'),
			dismissAnnouncement,
		}),
		[dismissAnnouncement, isInJsmBoundary, shouldShow],
	);
};
